<template>
    <label class="chk_article" :class="classes" :for="id">
        <input type="checkbox" :name="id" :id="id" :checked="modelValue" @click="$emit('update', id)"><span>{{label}}</span>
    </label>
</template>

<script>
export default {
    props: {
        id: String,
        label: String,
        classes: String,
        modelValue: Boolean
    }
}
</script>